import { Router } from '@angular/router';
import { AuthenticationService } from './services/authentication.service';
var AuthGuard = (function () {
    function AuthGuard(router, authService) {
        this.router = router;
        this.authService = authService;
    }
    AuthGuard.prototype.canActivate = function (route, state) {
        if (this.authService.isLoggedIn()) {
            return true;
        }
        this.router.navigate(['/login'], { queryParams: { returnUrl: state.url } });
        return false;
        // return true;
    };
    return AuthGuard;
}());
export { AuthGuard };



// WEBPACK FOOTER //
// /opt/app/src/app/auth-guard.service.ts.pre-build-optimizer.js